import { createReducer, on } from '@ngrx/store';

import { CommentsConfigActions } from './comments-config.actions';
import { CommentsConfigState, initialCommentsConfigState } from './comments-config.state';

export const commentsConfigReducer = createReducer<CommentsConfigState>(
  initialCommentsConfigState,
  on(CommentsConfigActions.loadCommentableTypes, (state) => ({
    ...state,
    loading: true,
    error: null
  })),
  on(CommentsConfigActions.loadCommentableTypesSuccess, (state, { entityTypes }) => ({
    ...state,
    entityTypes,
    loading: false
  })),
  on(CommentsConfigActions.loadCommentableTypesFailure, (state, { error }) => ({
    ...state,
    error,
    loading: false
  }))
);
